import React from 'react'
import { Form as RsForm, Row, Col, Label } from 'reactstrap'
import { Validator } from 'components/validation'
import { api as countriesApi } from 'store/modules/lookups/countries'
import { api as vineyardStylesApi } from 'store/modules/lookups/vineyardStyles'
import { api as produceStylesApi } from 'store/modules/lookups/produceStyles'
import { dialogTypes } from 'dialogs'
import { AddItemButton } from 'components/buttons'
import { Select } from 'components/select'
import { Input } from 'components/inputs'
import { ContactForm } from 'components/contactForm'
import { useStyles } from './form.css'

const Form = (props) => {
  const classes = useStyles()
  const { disabled, data, updateEntity, localize } = props
  const { entity } = data
  if (!entity) { return null }
  return (
    <RsForm>
      <Row>
        <Col sm={props.isInDialog ? 12 : 6}>
          <Label>{localize('common.name')}</Label>
          <Validator name='name' value={entity.name} required maxLength={255} disabled={disabled}>
            <Input value={entity.name} onChange={updateEntity('name')} placeholder={localize('common.name')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
      <Row><Col><hr /></Col></Row>
      <ContactForm entity={entity} updateEntity={updateEntity} localize={localize} disabled={disabled} />
      <Row>
        <Col sm={6}>
          <Label>{localize('producers.country')}</Label>
          <AddItemButton dialogType={dialogTypes.countryDetail} disabled={disabled} onCreatedEntity={updateEntity('country')}>
            <Validator name='country' value={entity.country} required disabled={disabled}>
              <Select
                dataSource={countriesApi.get}
                value={entity.country}
                onChange={updateEntity('country')}
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
        <Col sm={6}>
          <Label>{localize('producers.phoneNumber')}</Label>
          <Validator name='phoneNumber' value={entity.phoneNumber} maxLength={50} disabled={disabled}>
            <Input value={entity.phoneNumber} onChange={updateEntity('phoneNumber')} placeholder={localize('producers.phoneNumber')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
      <Row><Col><hr /></Col></Row>
      <Row>
        <Col sm={6}>
          <Label>{localize('producers.vineyardStyle')}</Label>
          <AddItemButton dialogType={dialogTypes.vineyardStyleDetail} disabled={disabled} onCreatedEntity={updateEntity('vineyardStyle')}>
            <Validator name='vineyardStyle' value={entity.vineyardStyle} required={false} disabled={disabled}>
              <Select
                dataSource={vineyardStylesApi.get}
                value={entity.vineyardStyle}
                onChange={updateEntity('vineyardStyle')}
                nullable={true}
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
        <Col sm={6}>
          <Label>{localize('producers.produceStyle')}</Label>
          <AddItemButton dialogType={dialogTypes.produceStyleDetail} disabled={disabled} onCreatedEntity={updateEntity('produceStyle')}>
            <Validator name='produceStyle' value={entity.produceStyle} required={false} disabled={disabled}>
              <Select
                dataSource={produceStylesApi.get}
                value={entity.produceStyle}
                nullable={true}
                onChange={updateEntity('produceStyle')}
                disabled={disabled} />
            </Validator>
          </AddItemButton>
        </Col>
      </Row>
      <Row className={classes.row}>
        <Col sm={12}>
          <Label>{localize('suppliers.comment')}</Label>
          <Validator name='comment' value={entity.comment} disabled={disabled}>
            <Input type={'textarea'} rows={5} value={entity.comment} onChange={updateEntity('comment')} placeholder={localize('suppliers.comment')} disabled={disabled} />
          </Validator>
        </Col>
      </Row>
    </RsForm>
  )
}

export default Form